import { Cookie } from "../Application/Cookie.js"

export class Accessibility
{
    Cookie = new Cookie()

	data = {}

	isHidden = true
	isDefault = true
	isDecrease = false
	isIncrease = true

	config = {
		wordSpacing: {
			minLevel: 0,
			maxLevel: 5,
			steps: {
				0: "",
				1: "4px",
				2: "8px",
				3: "12px",
				4: "16px",
				5: "20px",
			},
			cookie: {
				name: "AccessibilityWordSpacing", value: "0", domain: "", path: "/", expires: 1, secure: ""
			}
		},
		letterSpacing: {
			minLevel: 0,
			maxLevel: 5,
			steps: {
				0: "",
				1: "0px",
				2: "1px",
				3: "2px",
				4: "3px",
				5: "4px",
			},
			cookie: {
				name: "AccessibilityLetterSpacing", value: "0", domain: "", path: "/", expires: 1, secure: ""
			}
		},
		lineHeight: {
			minLevel: 0,
			maxLevel: 5,
			steps: {
				0: "",
				1: "1.2",
				2: "1.4",
				3: "1.6",
				4: "1.8",
				5: "2.0",
			},
			cookie: {
				name: "AccessibilityLineHeight", value: "0", domain: "", path: "/", expires: 1, secure: ""
			}
		},
		fontSize: {
			minLevel: 0,
			maxLevel: 5,
			steps: {
				0: "1px",
				1: "1.1px",
				2: "1.2px",
				3: "1.3px",
				4: "1.4px",
				5: "1.5px",
			},
			cookie: {
				name: "AccessibilityFontSize", value: "0", domain: "", path: "/", expires: 1, secure: ""
			}
		},
        functional: {
            cookie: {
                name: "Cookies_2nd"
            }
        }
	}

	accessibility = document.querySelector('[data-s~="Accessibility"]')
	buttonToggle = document.querySelectorAll('[data-s~="Accessibility:toggle"]')
	buttonReset = document.querySelector('[data-s~="Accessibility:reset"]')

	decreaseWordSpacing = document.querySelector('[data-s~="Accessibility:wordSpacing:decrease"]')
	increaseWordSpacing = document.querySelector('[data-s~="Accessibility:wordSpacing:increase"]')
	decreaseWordSpacingCounter = document.querySelector('[data-s~="Accessibility:wordSpacing:decrease:counter"]')
	increaseWordSpacingCounter = document.querySelector('[data-s~="Accessibility:wordSpacing:increase:counter"]')

	decreaseLetterSpacing = document.querySelector('[data-s~="Accessibility:letterSpacing:decrease"]')
	increaseLetterSpacing = document.querySelector('[data-s~="Accessibility:letterSpacing:increase"]')
	decreaseLetterSpacingCounter = document.querySelector('[data-s~="Accessibility:letterSpacing:decrease:counter"]')
	increaseLetterSpacingCounter = document.querySelector('[data-s~="Accessibility:letterSpacing:increase:counter"]')

	decreaseLineHeight = document.querySelector('[data-s~="Accessibility:lineHeight:decrease"]')
	increaseLineHeight = document.querySelector('[data-s~="Accessibility:lineHeight:increase"]')
	decreaseLineHeightCounter = document.querySelector('[data-s~="Accessibility:lineHeight:decrease:counter"]')
	increaseLineHeightCounter = document.querySelector('[data-s~="Accessibility:lineHeight:increase:counter"]')

	decreaseFontSize = document.querySelector('[data-s~="Accessibility:fontSize:decrease"]')
	increaseFontSize = document.querySelector('[data-s~="Accessibility:fontSize:increase"]')
	decreaseFontSizeCounter = document.querySelector('[data-s~="Accessibility:fontSize:decrease:counter"]')
	increaseFontSizeCounter = document.querySelector('[data-s~="Accessibility:fontSize:increase:counter"]')

	checkCookies()
	{
        let wordSpacingCookieVal = this.Cookie.read(this.config.wordSpacing.cookie.name)
        let letterSpacingVal = this.Cookie.read(this.config.letterSpacing.cookie.name)
        let lineHeightVal = this.Cookie.read(this.config.lineHeight.cookie.name)
        let fontSizeVal = this.Cookie.read(this.config.fontSize.cookie.name)

		this.data = {
			wordSpacing: wordSpacingCookieVal ? wordSpacingCookieVal : (this.data.wordSpacing ? this.data.wordSpacing : 0),
			letterSpacing: letterSpacingVal ? letterSpacingVal : (this.data.letterSpacing ? this.data.letterSpacing : 0),
			lineHeight: lineHeightVal ? lineHeightVal : (this.data.lineHeight ? this.data.lineHeight : 0),
			fontSize: fontSizeVal ? fontSizeVal : (this.data.fontSize ? this.data.fontSize : 0),
            functional: this.Cookie.read(this.config.functional.cookie.name)
		}
	}

	show()
	{
		this.accessibility.style.display = "flex"

		setTimeout(() => {
			this.accessibility.style.opacity = "1"
			this.accessibility.style.transform = "translateY(0)"
			this.accessibility.style.pointerEvents = "all"
		}, 100)
	}

	hide()
	{
		this.accessibility.style.opacity = null
		this.accessibility.style.transform = null
		this.accessibility.style.pointerEvents = null

		setTimeout(() => {
			this.accessibility.style.display = null
		}, 250)
	}

	setStyleWordSpacing(wordSpacing)
	{
		document.querySelectorAll("*").forEach(e => {
			e.style.wordSpacing = wordSpacing
		})

		if (this.data.wordSpacing == this.config.wordSpacing.minLevel) {
			this.decreaseWordSpacing.style.opacity = .5
			this.decreaseWordSpacing.style.cursor = "default"
			this.decreaseWordSpacing.disabled = true

			this.decreaseWordSpacingCounter.style.display = "none"
			this.increaseWordSpacingCounter.style.display = "none"
		}
		if (this.data.wordSpacing > this.config.wordSpacing.minLevel) {
			this.decreaseWordSpacing.style.opacity = 1
			this.decreaseWordSpacing.style.cursor = "pointer"
			this.decreaseWordSpacing.disabled = false

			if (this.isDecrease && !this.isIncrease) {
				this.increaseWordSpacingCounter.style.display = "none"
				this.decreaseWordSpacingCounter.style.display = "flex"
				this.decreaseWordSpacingCounter.children[0].children[0].textContent = this.data.wordSpacing
			}
			if (!this.isDecrease && this.isIncrease) {
				this.decreaseWordSpacingCounter.style.display = "none"
				this.increaseWordSpacingCounter.style.display = "flex"
				this.increaseWordSpacingCounter.children[0].children[0].textContent = this.data.wordSpacing
			}
		}
		if (this.data.wordSpacing == this.config.wordSpacing.maxLevel) {
			this.increaseWordSpacing.style.opacity = .5
			this.increaseWordSpacing.style.cursor = "default"
			this.increaseWordSpacing.disabled = true
		}
		if (this.data.wordSpacing < this.config.wordSpacing.maxLevel) {
			this.increaseWordSpacing.style.opacity = 1
			this.increaseWordSpacing.style.cursor = "pointer"
			this.increaseWordSpacing.disabled = false
		}
	}

	setStyleLetterSpacing(letterSpacing)
	{
		document.querySelectorAll("*").forEach(e => {
			e.style.letterSpacing = letterSpacing
		})

		if (this.data.letterSpacing == this.config.letterSpacing.minLevel) {
			this.decreaseLetterSpacing.style.opacity = .5
			this.decreaseLetterSpacing.style.cursor = "default"
			this.decreaseLetterSpacing.disabled = true

			this.decreaseLetterSpacingCounter.style.display = "none"
			this.increaseLetterSpacingCounter.style.display = "none"
		}
		if (this.data.letterSpacing > this.config.letterSpacing.minLevel) {
			this.decreaseLetterSpacing.style.opacity = 1
			this.decreaseLetterSpacing.style.cursor = "pointer"
			this.decreaseLetterSpacing.disabled = false

			if (this.isDecrease && !this.isIncrease) {
				this.increaseLetterSpacingCounter.style.display = "none"
				this.decreaseLetterSpacingCounter.style.display = "flex"
				this.decreaseLetterSpacingCounter.children[0].children[0].textContent = this.data.letterSpacing
			}
			if (!this.isDecrease && this.isIncrease) {
				this.decreaseLetterSpacingCounter.style.display = "none"
				this.increaseLetterSpacingCounter.style.display = "flex"
				this.increaseLetterSpacingCounter.children[0].children[0].textContent = this.data.letterSpacing
			}
		}
		if (this.data.letterSpacing == this.config.letterSpacing.maxLevel) {
			this.increaseLetterSpacing.style.opacity = .5
			this.increaseLetterSpacing.style.cursor = "default"
			this.increaseLetterSpacing.disabled = true
		}
		if (this.data.letterSpacing < this.config.letterSpacing.maxLevel) {
			this.increaseLetterSpacing.style.opacity = 1
			this.increaseLetterSpacing.style.cursor = "pointer"
			this.increaseLetterSpacing.disabled = false
		}
	}

	setStyleLineHeight(lineHeight)
	{
		document.querySelectorAll("*").forEach(e => {
			e.style.lineHeight = lineHeight
		})

		if (this.data.lineHeight == this.config.lineHeight.minLevel) {
			this.decreaseLineHeight.style.opacity = .5
			this.decreaseLineHeight.style.cursor = "default"
			this.decreaseLineHeight.disabled = true

			this.decreaseLineHeightCounter.style.display = "none"
			this.increaseLineHeightCounter.style.display = "none"
		}
		if (this.data.lineHeight > this.config.lineHeight.minLevel) {
			this.decreaseLineHeight.style.opacity = 1
			this.decreaseLineHeight.style.cursor = "pointer"
			this.decreaseLineHeight.disabled = false

			if (this.isDecrease && !this.isIncrease) {
				this.increaseLineHeightCounter.style.display = "none"
				this.decreaseLineHeightCounter.style.display = "flex"
				this.decreaseLineHeightCounter.children[0].children[0].textContent = this.data.lineHeight
			}
			if (!this.isDecrease && this.isIncrease) {
				this.decreaseLineHeightCounter.style.display = "none"
				this.increaseLineHeightCounter.style.display = "flex"
				this.increaseLineHeightCounter.children[0].children[0].textContent = this.data.lineHeight
			}
		}
		if (this.data.lineHeight == this.config.lineHeight.maxLevel) {
			this.increaseLineHeight.style.opacity = .5
			this.increaseLineHeight.style.cursor = "default"
			this.increaseLineHeight.disabled = true
		}
		if (this.data.lineHeight < this.config.lineHeight.maxLevel) {
			this.increaseLineHeight.style.opacity = 1
			this.increaseLineHeight.style.cursor = "pointer"
			this.increaseLineHeight.disabled = false
		}
	}

	setStyleFontSize(fontSize)
	{
		document.querySelector("html").style.fontSize = fontSize

		if (this.data.fontSize == this.config.fontSize.minLevel) {
			this.decreaseFontSize.style.opacity = .5
			this.decreaseFontSize.style.cursor = "default"
			this.decreaseFontSize.disabled = true

			this.decreaseFontSizeCounter.style.display = "none"
			this.increaseFontSizeCounter.style.display = "none"
		}
		if (this.data.fontSize > this.config.fontSize.minLevel) {
			this.decreaseFontSize.style.opacity = 1
			this.decreaseFontSize.style.cursor = "pointer"
			this.decreaseFontSize.disabled = false

			if (this.isDecrease && !this.isIncrease) {
				this.increaseFontSizeCounter.style.display = "none"
				this.decreaseFontSizeCounter.style.display = "flex"
				this.decreaseFontSizeCounter.children[0].children[0].textContent = this.data.fontSize
			}
			if (!this.isDecrease && this.isIncrease) {
				this.decreaseFontSizeCounter.style.display = "none"
				this.increaseFontSizeCounter.style.display = "flex"
				this.increaseFontSizeCounter.children[0].children[0].textContent = this.data.fontSize
			}
		}
		if (this.data.fontSize == this.config.fontSize.maxLevel) {
			this.increaseFontSize.style.opacity = .5
			this.increaseFontSize.style.cursor = "default"
			this.increaseFontSize.disabled = true
		}
		if (this.data.fontSize < this.config.fontSize.maxLevel) {
			this.increaseFontSize.style.opacity = 1
			this.increaseFontSize.style.cursor = "pointer"
			this.increaseFontSize.disabled = false
		}
	}

	setDecreaseWordSpacing(index)
	{
		this.Cookie.delete(this.config.wordSpacing.cookie.name)
		this.config.wordSpacing.cookie.value = index

        if (this.cookiesPermission()) {
            this.Cookie.create(this.config.wordSpacing.cookie)
        } else {
            this.data.wordSpacing = index;
        }

		this.checkCookies()

		this.setStyleWordSpacing(this.config.wordSpacing.steps[index])

		this.setStyleButtonReset()
	}

	setIncreaseWordSpacing(index)
	{
		this.Cookie.delete(this.config.wordSpacing.cookie.name)
		this.config.wordSpacing.cookie.value = index

        if (this.cookiesPermission()) {
            this.Cookie.create(this.config.wordSpacing.cookie)
        } else {
            this.data.wordSpacing = index;
        }

		this.checkCookies()

		this.setStyleWordSpacing(this.config.wordSpacing.steps[index])

		this.setStyleButtonReset()
	}

	setDecreaseLetterSpacing(index)
	{
		this.Cookie.delete(this.config.letterSpacing.cookie.name)
		this.config.letterSpacing.cookie.value = index

        if (this.cookiesPermission()) {
            this.Cookie.create(this.config.letterSpacing.cookie)
        } else {
            this.data.letterSpacing = index;
        }

		this.checkCookies()

		this.setStyleLetterSpacing(this.config.letterSpacing.steps[index])

		this.setStyleButtonReset()
	}

	setIncreaseLetterSpacing(index)
	{
		this.Cookie.delete(this.config.letterSpacing.cookie.name)
		this.config.letterSpacing.cookie.value = index

        if (this.cookiesPermission()) {
            this.Cookie.create(this.config.letterSpacing.cookie)
        } else {
            this.data.letterSpacing = index;
        }

		this.checkCookies()

		this.setStyleLetterSpacing(this.config.letterSpacing.steps[index])

		this.setStyleButtonReset()
	}

	setDecreaseLineHeight(index)
	{
		this.Cookie.delete(this.config.lineHeight.cookie.name)
		this.config.lineHeight.cookie.value = index

        if (this.cookiesPermission()) {
            this.Cookie.create(this.config.lineHeight.cookie)
        } else {
            this.data.lineHeight = index;
        }

		this.checkCookies()

		this.setStyleLineHeight(this.config.lineHeight.steps[index])

		this.setStyleButtonReset()
	}

	setIncreaseLineHeight(index)
	{
		this.Cookie.delete(this.config.lineHeight.cookie.name)
		this.config.lineHeight.cookie.value = index

        if (this.cookiesPermission()) {
            this.Cookie.create(this.config.lineHeight.cookie)
        } else {
            this.data.lineHeight = index;
        }

		this.checkCookies()

		this.setStyleLineHeight(this.config.lineHeight.steps[index])

		this.setStyleButtonReset()
	}

	setDecreaseFontSize(index)
	{
		this.Cookie.delete(this.config.fontSize.cookie.name)
		this.config.fontSize.cookie.value = index

        if (this.cookiesPermission()) {
            this.Cookie.create(this.config.fontSize.cookie)
        } else {
            this.data.fontSize = index;
        }

		this.checkCookies()

		this.setStyleFontSize(this.config.fontSize.steps[index])

		this.setStyleButtonReset()
	}

	setIncreaseFontSize(index)
	{
		this.Cookie.delete(this.config.fontSize.cookie.name)
		this.config.fontSize.cookie.value = index

        if (this.cookiesPermission()) {
            this.Cookie.create(this.config.fontSize.cookie)
        } else {
            this.data.fontSize = index;
        }

		this.checkCookies()

		this.setStyleFontSize(this.config.fontSize.steps[index])

		this.setStyleButtonReset()
	}

	setStyleButtonReset()
	{
		if (
			this.data.wordSpacing > this.config.wordSpacing.minLevel ||
			this.data.letterSpacing > this.config.letterSpacing.minLevel ||
			this.data.lineHeight > this.config.lineHeight.minLevel ||
			this.data.fontSize > this.config.fontSize.minLevel
		) {
			this.isDefault = false

			this.buttonReset.style.opacity = 1
			this.buttonReset.style.cursor = "pointer"
			this.buttonReset.disabled = false
		} else if (
			this.data.wordSpacing == this.config.wordSpacing.minLevel &&
			this.data.letterSpacing == this.config.letterSpacing.minLevel &&
			this.data.lineHeight == this.config.lineHeight.minLevel &&
			this.data.fontSize == this.config.fontSize.minLevel
		) {
			this.isDefault = true

			this.buttonReset.style.opacity = .5
			this.buttonReset.style.cursor = "default"
			this.buttonReset.disabled = true
		}
	}

	check()
	{
		if (this.isHidden) {
			this.isHidden = false
			this.show()
		} else {
			this.isHidden = true
			this.hide()
		}
	}

    cookiesPermission()
    {
        return (this.data.functional === "true")
    }

	watch()
	{
		this.buttonToggle.forEach(e => {
			e.addEventListener("click", () => {
				this.check()
			})
		})

		this.buttonReset && this.buttonReset.addEventListener("click", () => {
			if (!this.isDefault) {
				this.setDecreaseWordSpacing(0)
				this.setDecreaseLetterSpacing(0)
				this.setDecreaseLineHeight(0)
				this.setDecreaseFontSize(0)
			}
		})

		this.decreaseWordSpacing && this.decreaseWordSpacing.addEventListener("click", () => {
			if (this.data.wordSpacing > this.config.wordSpacing.minLevel) {
				this.isDecrease = true
				this.isIncrease = false
				this.setDecreaseWordSpacing(parseInt(this.data.wordSpacing) - 1)
			}
		})

		this.increaseWordSpacing && this.increaseWordSpacing.addEventListener("click", () => {
			if (this.data.wordSpacing < this.config.wordSpacing.maxLevel) {
				this.isDecrease = false
				this.isIncrease = true
				this.setIncreaseWordSpacing(parseInt(this.data.wordSpacing) + 1)
			}
		})

		this.decreaseLetterSpacing && this.decreaseLetterSpacing.addEventListener("click", () => {
			if (this.data.letterSpacing > this.config.letterSpacing.minLevel) {
				this.isDecrease = true
				this.isIncrease = false
				this.setDecreaseLetterSpacing(parseInt(this.data.letterSpacing) - 1)
			}
		})

		this.increaseLetterSpacing && this.increaseLetterSpacing.addEventListener("click", () => {
			if (this.data.letterSpacing < this.config.letterSpacing.maxLevel) {
				this.isDecrease = false
				this.isIncrease = true
				this.setIncreaseLetterSpacing(parseInt(this.data.letterSpacing) + 1)
			}
		})

		this.decreaseLineHeight && this.decreaseLineHeight.addEventListener("click", () => {
			if (this.data.lineHeight > this.config.lineHeight.minLevel) {
				this.isDecrease = true
				this.isIncrease = false
				this.setDecreaseLineHeight(parseInt(this.data.lineHeight) - 1)
			}
		})

		this.increaseLineHeight && this.increaseLineHeight.addEventListener("click", () => {
			if (this.data.lineHeight < this.config.lineHeight.maxLevel) {
				this.isDecrease = false
				this.isIncrease = true
				this.setIncreaseLineHeight(parseInt(this.data.lineHeight) + 1)
			}
		})

		this.decreaseFontSize && this.decreaseFontSize.addEventListener("click", () => {
			if (this.data.fontSize > this.config.fontSize.minLevel) {
				this.isDecrease = true
				this.isIncrease = false
				this.setDecreaseFontSize(parseInt(this.data.fontSize) - 1)
			}
		})

		this.increaseFontSize && this.increaseFontSize.addEventListener("click", () => {
			if (this.data.fontSize < this.config.fontSize.maxLevel) {
				this.isDecrease = false
				this.isIncrease = true
				this.setIncreaseFontSize(parseInt(this.data.fontSize) + 1)
			}
		})
	}

	run()
	{
		this.checkCookies()

		if (!this.data.wordSpacing && this.cookiesPermission()) {
			this.Cookie.create(this.config.wordSpacing.cookie)
		}
		if (!this.data.letterSpacing && this.cookiesPermission()) {
			this.Cookie.create(this.config.letterSpacing.cookie)
		}
		if (!this.data.lineHeight && this.cookiesPermission()) {
			this.Cookie.create(this.config.lineHeight.cookie)
		}
		if (!this.data.fontSize && this.cookiesPermission()) {
			this.Cookie.create(this.config.fontSize.cookie)
		}

		this.checkCookies()

		this.setStyleWordSpacing(this.config.wordSpacing.steps[this.data.wordSpacing])
		this.setStyleLetterSpacing(this.config.letterSpacing.steps[this.data.letterSpacing])
		this.setStyleLineHeight(this.config.lineHeight.steps[this.data.lineHeight])
		this.setStyleFontSize(this.config.fontSize.steps[this.data.fontSize])
		this.setStyleButtonReset()
	}
}
